export default __webpack_public_path__ + "media/images/dividers/hero-bottom-460231030fbaba457b9bcb14a4c03854.svg";